var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUparrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.982 11.9783C18.8511 11.9801 18.7214 11.9519 18.6011 11.8957C18.4807 11.8394 18.3725 11.7563 18.2834 11.6517L10 2.63533L1.71657 11.6517C1.31736 12.0872 0.698603 12.0872 0.299401 11.6517C-0.0998004 11.2161 -0.0998004 10.541 0.299401 10.1054L9.3014 0.326801C9.7006 -0.108771 10.3194 -0.108771 10.7186 0.326801L19.7006 10.1272C20.0998 10.5627 20.0998 11.2379 19.7006 11.6734C19.501 11.8912 19.2415 12.0001 19.002 12.0001L18.982 11.9783Z",
    fill: "#2B2B2B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUparrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Uparrow.ecd624c9b0a4faaea2721e00c51c6ea1.svg";